import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_COOLDINATORS_ADD, MANAGE_COOLDINATORS_DELETE, MANAGE_COOLDINATORS_EDIT, MANAGE_COOLDINATORS_LIST, MANAGE_COOLDINATORS_VIEW } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const coordinatorsApi = createApi({

    reducerPath: 'coordinatorsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/guardian/coordinator",
    }),
    tagTypes: ["CoordinatorsList", "CoordinatorDetails"],
    endpoints: (builder) => ({

        // get coordinators list
        getCoordinatorsList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "desc" } }) => ({
                method: "PATCH",
                url: MANAGE_COOLDINATORS_LIST,
                data: { search, status: status?.value || "", page, limit, sort, },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["CoordinatorsList"]
        }),

        // get coordinators data
        getCoordinatorDetail: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_COOLDINATORS_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["CoordinatorDetails"]
        }),

        // create coordinator
        createCoordinator: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_COOLDINATORS_ADD,
                data
            }),
            invalidatesTags: ["CoordinatorsList"]
        }),

        // update coordinator
        updateCoordinator: builder.mutation({
            query: ({ data, coordinatorId }) => ({
                method: "PUT",
                url: `${MANAGE_COOLDINATORS_EDIT}/${coordinatorId}`,
                data
            }),
            invalidatesTags: ["CoordinatorsList", "CoordinatorDetails"]
        }),

        // delete coordinator
        deleteCoordinator: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_COOLDINATORS_DELETE}/${id}`
            }),
            invalidatesTags: ["CoordinatorsList", "CoordinatorDetails"]
        })
    }),
})

export const {

    useGetCoordinatorsListQuery,
    useCreateCoordinatorMutation,
    useDeleteCoordinatorMutation,
    useUpdateCoordinatorMutation,
    useGetCoordinatorDetailQuery

} = coordinatorsApi;